import { useEffect, useState, useRef } from 'react';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Col, Table, Button, Input, Space } from 'antd'
import { SearchOutlined } from '@ant-design/icons';
import IntlMessages from '../../components/utility/intlMessages';
import { getClinicsService } from '../../redux/systemInfos/systemInfosServices';
import Highlighter from 'react-highlight-words';
import { DvIntlMessages } from '../../components/utility/dvGeneralUtilities';

function ClinicsPage(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [clinicsData, setClinicsData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");

  const searchInput = useRef(null);

  useEffect(() => {
    setIsLoading(true);
    getClinicsService().then((response) => {
      setIsLoading(false);
      if (response.results) {
        const clinics = response.results.clinics.map(c => {
          return { ...c, key: c.id };
        });
        setClinicsData(clinics);
      } else {
        setClinicsData([]);
      }
    }, () => {
      setClinicsData([]);
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            {DvIntlMessages('general.search')}
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters);
              handleSearch(selectedKeys, confirm, dataIndex);
              setSearchText('');
            }}
            size="small"
            style={{ width: 90 }}
          >
            {DvIntlMessages('general.reset')}
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            {DvIntlMessages('general.closeLower')}
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      if (dataIndex === "id") {
        return String(record.id) === value;
      }
      return record[dataIndex] ? record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(String(value).toLowerCase()) : false;
    },
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.current?.select());
      }
    },
    render: (text, record) => {
      const innerText = searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      );

      if (dataIndex === 'title') {
        return <Button style={{ padding: 0, border: 0, height: 'auto', cursor: 'pointer' }} type='link' onClick={() => props.history.push(`/Dashboard/clinicDetails/${record.id}`)}>{innerText}</Button>
      }

      return innerText;
    },
  });

  const handleSearch = (
    selectedKeys, confirm, dataIndex,
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const columns = [
    {
      key: "title",
      title: <IntlMessages id="clinicsPage.table.title" />,
      dataIndex: 'title',
      sorter: (a, b) => a.title.localeCompare(b.title),
      onFilter: (value, record) => record.title.indexOf(value) === 0,
      ellipsis: true,
      ...getColumnSearchProps('title'),
    },
    {
      key: "id",
      title: <IntlMessages id="clinicsPage.table.id" />,
      dataIndex: 'id',
      sorter: (a, b) => a.id - b.id,
      onFilter: (value, record) => record.id.indexOf(value) === 0,
      ellipsis: true,
      ...getColumnSearchProps('id'),
    },
    {
      key: "uniqueId",
      title: <IntlMessages id="clinicsPage.table.uniqueId" />,
      dataIndex: 'uniqueId',
      sorter: (a, b) => a.uniqueId.localeCompare(b.uniqueId),
      ellipsis: true
    },
    {
      key: "oncoEmailAddress",
      title: <IntlMessages id="general.email" />,
      dataIndex: 'oncoEmailAddress',
      sorter: (a, b) => a.oncoEmailAddress && b.oncoEmailAddress ? a.oncoEmailAddress.localeCompare(b.oncoEmailAddress) : -1,
      onFilter: (value, record) => record.oncoEmailAddress.indexOf(value) === 0,
      ellipsis: true,
      ...getColumnSearchProps('oncoEmailAddress'),
    }
  ];

  function handleCreateNewClinic() {
    props.history.push('/Dashboard/createNewClinic')
  }

  return (
    <div style={{ height: '-webkit-fill-available', display: 'inherit', flexDirection: 'inherit' }}>
      <Row style={{ display: 'flex' }}>
        <Col style={{ justifyContent: 'right', marginBottom: 16 }}>
          <Button onClick={handleCreateNewClinic}>
            <IntlMessages id="clinicsPage.createNewClinic" />
          </Button>
        </Col>
      </Row>
      <Row style={{ flex: 1 }}>
        <Table
          loading={isLoading}
          bordered={true}
          showHeader
          pagination={{ showSizeChanger: true, size: 'small', showTotal: (total, range) => `Total ${total} items` }}
          columns={columns}
          dataSource={clinicsData}
          sortDirections={['ascend', 'descend', 'ascend']}
        />
      </Row>
    </div>
  )
}

ClinicsPage.propTypes = {
};


const mapActionsToProps = {
};

function mapStateToProps(state) {
  return {

  };
}

const wrappedClinicsPage = withRouter(ClinicsPage);
const connectedClinicsPage = connect(mapStateToProps, mapActionsToProps)(wrappedClinicsPage);
export default connectedClinicsPage;